import React, { useRef, useState } from "react";
import OpportunityDateCard from "./OpportunityDateCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import Image from "next/image";
import { useGetVillasComingChances } from "@/api/api";

const OpportunitySlider = ({ villa }) => {
  //TODO: Bu component bağlanacak. API yazılması lazım.
  const swiperRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const onSwiperChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const { data: lastMinutes } = useGetVillasComingChances(villa?.id);

  if (!lastMinutes?.data?.length > 0) return;
  return (
    <div className="flex flex-col lg:mb-[68px] md:mb-8 mb-4 z-0">
      <div className="flex items-center justify-between gap-4 mb-3 md:justify-start lg:gap-9 lg:mb-7 xsm:mb-4">
        <span className="text-2xl font-bold leading-normal text-themeBlack">
          Fırsat Tarihler
        </span>
        <div className="flex items-center justify-between gap-4 lg:gap-7">
          <button
            onClick={handlePrev}
            disabled={isBeginning}
            className={`flex items-center justify-center w-12 h-12 p-[18px] gap-1.5 rounded-full bg-white shadow-customShadow ${
              isBeginning ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <Image
              src="/icons/left.svg"
              width={14}
              height={7}
              alt="Left Arrow"
              className="object-contain"
            />
          </button>
          <button
            onClick={handleNext}
            disabled={isEnd}
            className={`flex items-center justify-center w-12 h-12 p-[18px] gap-1.5 rounded-full bg-white shadow-customShadow ${
              isEnd ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <Image
              src="/icons/rightcccc.svg"
              width={14}
              height={7}
              alt="Right Arrow"
              className="object-contain"
            />
          </button>
        </div>
      </div>
      <div className="relative">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          onSlideChange={(swiper) => onSwiperChange(swiper)}
          spaceBetween={12}
          slidesPerView={2}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 23,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 23,
            },
            1280: {
              slidesPerView: 2,
              spaceBetween: 23,
            },
          }}
        >
          {lastMinutes?.data?.map((opportunity, index) => (
            <SwiperSlide key={index}>
              <OpportunityDateCard item={opportunity} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default OpportunitySlider;
